import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import {
  IGetStablecoinDataByIdRequest,
  IStablecoinApi,
  IStablecoinDetailsDto,
  IStablecoinDto,
  IStablecoinReportDto,
  IStablecoinReserveDto,
} from '@/api/stablecoin/stablecoin.types';

export class StablecoinApi implements IStablecoinApi {
  private getBaseUrl(): string {
    return ApiEndpoints.STABLECOIN;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getStablecoins() {
    return this.httpClient.get<IStablecoinDto[]>(this.getBaseUrl());
  }

  getReservesById({ agioId, ...payload }: IGetStablecoinDataByIdRequest) {
    const params = {
      ...payload,
    };

    return this.httpClient.get<IStablecoinReserveDto[]>(`${this.getBaseUrl()}${agioId}/reserves/`, {
      params,
    });
  }

  getReportsById({ agioId, ...payload }: IGetStablecoinDataByIdRequest) {
    const params = {
      ...payload,
    };

    return this.httpClient.get<IStablecoinReportDto[]>(`${this.getBaseUrl()}${agioId}/reports/`, {
      params,
    });
  }

  getDetailsById(agioId: string) {
    return this.httpClient.get<IStablecoinDetailsDto>(`${this.getBaseUrl()}${agioId}/details/`);
  }
}
